import React from "react";
import '../index.css';
import Navbar from "./navbar";
import "../css/favourites.css"
import Footer from "./footer";


function Favourites(){
    
    const [favourite , setFavourite] = React.useState([])

    return(
        <div className="flex flex-col min-h-screen">
            <Navbar/>
            <div className="fav flex flex-1 flex-grow">

        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-amber-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob pointer-events-none -z-10"></div>
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000 pointer-events-none -z-10"></div>
        <div className="absolute bottom-1/3 left-1/3 w-64 h-64 bg-amber-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000 pointer-events-none -z-10"></div>

        
            {favourite.length < 1 &&
                <div className="empty flex justify-center items-center w-full">
                    <div className="content text-center">
                        <h1 className="text-2xl font-bold mb-3">Favourites</h1>
                        <h3 className="text-lg font-semibold mb-2">SAVE YOUR FAVOURITE ITEMS</h3>
                        <p className="mb-6">Want to save the items that you love? Just click on the <br></br>heart symbol beside the item and it will show up here.</p>      
                        <a href="/" className="px-6 py-3 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-all duration-300">Browse now</a>
                    </div>        
                </div>
            }
            </div>
            <Footer/>

                    <style jsx>{`
          @keyframes blob {
            0% {
              transform: scale(1);
            }
            33% {
              transform: scale(1.1) translate(10%, 10%);
            }
            66% {
              transform: scale(0.9) translate(-10%, -10%);
            }
            100% {
              transform: scale(1);
            }
          }
          .animate-blob {
            animation: blob 7s infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          .animation-delay-4000 {
            animation-delay: 4s;
          }
        `}</style>
        </div>
    )
}

export default Favourites